const maxBattery = 5;

export const getBatteryPercentage = (value) => (100 * value) / maxBattery;
